import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const DISABLED_FEATURE_MESSAGE = "This feature is currently disabled.";

/**
 * Wraps an action (typically a disabled Button) so that, when `disabled` is true, hovering shows a
 * tooltip explaining the feature is switched off. Disabled buttons swallow pointer events, so we
 * wrap in a focusable span (the tooltip trigger) and mirror the message onto aria-label for
 * accessibility and testability. When not disabled, children render untouched.
 */
export function DisabledFeatureTooltip({ disabled, children }: { disabled: boolean; children: ReactNode }) {
  if (!disabled) return <>{children}</>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-block" tabIndex={0} aria-label={DISABLED_FEATURE_MESSAGE}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{DISABLED_FEATURE_MESSAGE}</TooltipContent>
    </Tooltip>
  );
}
